export const maxSearchSuggestions = 3;
